module.exports = __webpack_public_path__ + "img/8_port.prt.00437ab8.jpg";